import React, { useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";

import Banner from "../generalBanner/Banner";
import ContainerTemplate from "../generalContainer/ContainerTemplate";
import HaveQuestions from "../../components/HaveQuestions";
import HowWork from "./HowWork";
import WhyProduct from "./WhyProduct";
// import RealImpact from "./RealImpact";
// import OurProcess from "./OurProcess";

// Practice BuiltContainer
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import Groups_2OutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";

// // Our Approach Container
// import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
// import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
// import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
// import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
// import HeightOutlinedIcon from "@mui/icons-material/HeightOutlined";

// Banner
import bgImage from "../../assets/practicePage.png";
const bannerTitle = "We Are a Practice";
const bannerDesc =
  "Inspired by the tradition of professional practices in medicine and law, our firm is built on the principles of “The Practice.” We apply this same level of vocational dedication and specialized expertise to your digital assets.";

// Practice Built Container
const practiceBuiltTitle = "A Practice Built on Knowledge and Experience";
const practiceBuiltDesc =
  "We transcend traditional consulting; we are active practitioners. Our methodology is built on extensive, real-world execution and a profound mastery of Digital Asset Management. Partnering directly with your team, we engineer, deploy, and optimize bespoke DAM solutions to drive measurable business value.";

const practiceBuiltCards = [
  {
    title: "Hands-On Execution",
    description: "We actively implement solutions, not just recommend strategies.",
    icon: BuildOutlinedIcon,
  },
  {
    title: "Real-World Experience",
    description:
      "Our expertise is built from working on real DAM projects across industries.",
    icon: WorkOutlineOutlinedIcon,
  },
  {
    title: "Collaborative Approach",
    description: "We work as an extension of your team throughout the journey.",
    icon: Groups_2OutlinedIcon,
  },
  {
    title: "Continuous Learning",
    description: "We evolve with industry trends, tools, and best practices.",
    icon: AutoStoriesOutlinedIcon,
  },
  {
    title: "Metadata & Taxonomy",
    description: "Organize assets with structured metadata for easy search and access.",
    icon: LocalOfferOutlinedIcon,
  },
  {
    title: "Governance & Compliance",
    description: "Ensure secure, standardized, and compliant asset management practices.",
    icon: VerifiedUserOutlinedIcon,
  },
];

// // Our Approach Container
// const ourApproachTitle = "Our Approach";
// const ourApproachDesc = "How We Deliver Product-Agnostic Value";
// const ourApproachCards = [
//   {
//     title: "Requirement-First Strategy",
//     description: "We deeply understand your workflows before suggesting tools.",
//     icon: FactCheckOutlinedIcon,
//   },
//   {
//     title: "Multi-Vendor Expertise",
//     description: "Experience across leading DAM platforms.",
//     icon: AccountTreeOutlinedIcon,
//   },
//   {
//     title: "Technology Evaluation",
//     description: "Compare tools based on features, scalability, and cost.",
//     icon: SearchOutlinedIcon,
//   },

//   {
//     title: "Integration-Ready Planning",
//     description: "Ensure seamless integration with your ecosystem.",
//     icon: ExtensionOutlinedIcon,
//   },

//   {
//     title: "User-Centric Selection",
//     description: "Focus on adoption, usability, and real workflows.",
//     icon: HowToRegOutlinedIcon,
//   },

//   {
//     title: "Long-Term Scalability",
//     description: "Solutions built for future growth—not short-term fixes.",
//     icon: HeightOutlinedIcon,
//   },
// ];

const PracticePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }}>
      <Box /*sx={{ maxWidth: "1440px" }}*/>
        <Banner title={bannerTitle} description={bannerDesc} image={bgImage} />
        <ContainerTemplate
          title={practiceBuiltTitle}
          description={practiceBuiltDesc}
          cardsData={practiceBuiltCards}
        />
        <HowWork />
        <WhyProduct />
        {/* Have Questions Section */}
        <HaveQuestions />
      </Box>
    </Box>
  );
};

export default PracticePage;
